import { createAction } from "redux-actions"

import {
  REQUEST_ADD,
  RECEIVE_ADD,
  REQUEST,
  RECEIVE,
  APPLY_FILTER,
  SET_FILTER,
  SAVE_UI,
  SET_CURRENT_FILTER
} from "./constants"

export const requestAdd = createAction(REQUEST_ADD)
export const receiveAdd = createAction(RECEIVE_ADD)
export const request = createAction(REQUEST)
export const receive = createAction(RECEIVE)
export const setFilter = createAction(SET_FILTER)
export const applyFilter = createAction(APPLY_FILTER)
export const saveUi = createAction(SAVE_UI)
export const setCurrentFilter = createAction(SET_CURRENT_FILTER)
